interface FuseCountDownButtonProps {
  timer: number;
  text: string;
  onClick: () => void;
}

/**
 * Component used for doing a countdown element with a "timer"
 * indicated by a background color (as a fuse).
 * @param {number} props.timer - Number between 0 and 100 indicating the "fuse" timer. 
 * This number must be dynamic to see the timer animation.
 * @param {string} props.text - String used for this button.
 * @param {function} props.onClick - Callback function used when clicking the text.
 * @returns 
 */
const FuseCountDownButton: React.FC<FuseCountDownButtonProps> = ({
  timer,
  text,
  onClick,
}) => {
  return (
    <div className="self-stretch h-[46px] rounded justify-start items-center gap-2 inline-flex relative">
      <div
        className="absolute w-full h-full bg-secondary-100 rounded"
        style={{ width: `${timer}%` }}
      />
      <div className="w-full h-full px-5 py-3 rounded justify-center items-center gap-2 inline-flex relative">
        <div
          className="text-secondary-600 hover:underline text-lg font-semibold font-sans leading-snug select-none cursor-pointer z-10"
          onClick={onClick}
        >
          {text}
        </div>
      </div>
    </div>
  );
};

export default FuseCountDownButton;
